// Bảng ngũ hành mặc định - map từ ngũ hành sang các thiên can/địa chi tương ứng
const NGU_HANH_DEFAULT = {
  "Thổ": ["Mậu", "Kỷ", "Thìn", "Tuất", "Sửu", "Mùi"],
  "Kim": ["Canh", "Tân", "Thân", "Dậu"],
  "Thủy": ["Nhâm", "Quý", "Hợi", "Tý"],
  "Mộc": ["Giáp", "Ất", "Dần", "Mão"],
  "Hỏa": ["Bính", "Đinh", "Tỵ", "Ngọ"]
};

/**
 * Kiểm tra xem một giá trị (thiên can hoặc địa chi) có phải là dụng thần hay không
 * @param {string} value - Giá trị cần kiểm tra (thiên can hoặc địa chi)
 * @param {string} dungThan - Chuỗi dụng thần từ profile (ví dụ: "Kim, Hoả, Thổ")
 * @param {Array} dungThanCaiDat - Mảng cài đặt dụng thần cụ thể (thiên can hoặc địa chi)
 * @param {boolean} checkDungThan - Flag kiểm tra có bật dụng thần hay không
 * @returns {boolean} - true nếu là dụng thần, false nếu không
 */
export const handleCheckDungThan = (value, dungThan, dungThanCaiDat, checkDungThan) => {
  if (!checkDungThan) return false;

  // Nếu có cài đặt dụng thần cụ thể, kiểm tra trong danh sách đó
  if (dungThanCaiDat && dungThanCaiDat.length > 0) {
    return dungThanCaiDat.includes(value);
  }

  // Không có cài đặt: tô theo ngũ hành mặc định
  if (typeof dungThan !== 'string' || !dungThan) return false;

  const dungThanArray = dungThan.split(',').filter(Boolean).map(nh => nh.trim());

  return dungThanArray.some(nh => {
    const values = NGU_HANH_DEFAULT[nh];
    return values && values.includes(value);
  });
};

export { NGU_HANH_DEFAULT };
